export default "__VITE_ASSET__3MqGXDID__"